import { Component, OnInit } from '@angular/core';
import {UserService} from '../user.service';

import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-course',
  templateUrl: './course.component.html'
})
export class CourseComponent implements OnInit {

  constructor(private userService: UserService, private router: Router, private activatedRoute: ActivatedRoute) {}

  name = '';

  lab_number = -1;

  ngOnInit() {

    this.name = this.userService.fullname;


    //this.activatedRoute.snapShot.paramMap.get("labNumber");

	this.setLabNumber( Number(this.activatedRoute.firstChild.snapshot.paramMap.get("labNumber")));
    console.log(this.activatedRoute.firstChild.snapshot.paramMap)
/*  */
     this.activatedRoute.firstChild.paramMap.subscribe( params => {

	     this.setLabNumber( Number(params.get("labNumber") ) );
     });



  }

  logout() {
    this.userService.fullname = "";
    this.userService.user = null;
    this.router.navigate(['/']);
  }

  setLabNumber(num) {
    this.lab_number = num;

    this.router.navigate([`/course/p1/${this.lab_number}`]);
  }

}



// WEBPACK FOOTER //
// ./src/app/course/course.component.ts